import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Inject,
	OnDestroy,
	OnInit,
	ViewContainerRef,
	ViewEncapsulation,
} from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CoreContentState, TranslationAction } from "@obg/ngx.core.content";
import { RouteService } from "@obg/ngx.router";
import { ComponentFactoryService } from "@obg/ngx.ui.core";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

import { DialogRouteData } from "../dialog.model";

@Component({
	templateUrl: "./dialog-route.container.html",
	styleUrls: ["./dialog-route.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DialogRouteContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-dialog-route") hostCssClass = true;

	isBusy = true;
	private data$$: Subscription | undefined;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: DialogRouteData,
		private store: Store<CoreContentState>,
		private compenentFactoryResolver: ComponentFactoryService,
		private routeService: RouteService,
		private changeDetectorRef: ChangeDetectorRef,
		private viewContainerRef: ViewContainerRef
	) {}

	ngOnInit() {
		this.data$$ = this.routeService
			.getRouteConfig$(this.data.routeName)
			.pipe(
				tap((routeConfig) => {
					this.isBusy = false;
					this.viewContainerRef
						.createComponent(this.compenentFactoryResolver.get(routeConfig!.component!))
						.changeDetectorRef.markForCheck();
					this.store.dispatch(TranslationAction.get([routeConfig!.data!.product]));
				})
			)
			.subscribe(() => this.changeDetectorRef.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}
}
